module.exports = __webpack_public_path__ + "img/wallet.52a37832.svg";